import React, { Component } from 'react'
import axios from 'axios'
import { Grid, Row, Col, Table } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux'
import { string } from 'prop-types'

// utils
import config from '../config'
import { getAuthToken } from '../utils/sessionStorage'

class Backlog extends Component {
  constructor () {
    super()
    this.state = {
      backlogItens: []
    }

    this.onSelectChange = this.onSelectChange.bind(this)
  }
  componentDidMount () {
    axios({
      method: 'GET',
      headers: {'X-User-Token': getAuthToken()},
      url: `${config.url}/backlog/itau`
    })
      .then((res) => {
        this.setState({
          backlogItens: res.data
        })
      })
  }
  onSelectChange (event, item, type) {
    let value = event.target.value
    axios({
      method: 'PUT',
      headers: {'X-User-Token': getAuthToken()},
      url: `${config.url}/backlog/itau/${item.id}`,
      data: {
        [type]: value
      }
    })
      .then((res) => {
        toastr.success('Item atualizado com sucesso!')
        this.setState({
          backlogItens: res.data
        })
      })
      .catch((err) => {
        toastr.error('Ocorreu um erro. Tente novamente.')
      })
  }
  render () {
    const { profile } = this.props
    console.log('Profile:', profile)
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <Table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Descrição</th>
                  <th>Tipo</th>
                  <th style={{ width: '10%' }} className='text-right'>Valor PF</th>
                  <th style={{ width: '10%' }} className='text-right'>Valor PJ</th>
                  <th style={{ width: '10%' }} className='text-right'>Esforço</th>
                </tr>
              </thead>
              <tbody>
                {this.state.backlogItens.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.category}</td>
                    <td className='text-right'>
                      <select
                        onChange={(e) => { this.onSelectChange(e, item, 'value_pf') }}
                        defaultValue={item.value_pf}
                        disabled={profile !== 'itau'}
                      >
                        <option value='' />
                        <option value='P'>P</option>
                        <option value='M'>M</option>
                        <option value='G'>G</option>
                      </select>
                    </td>
                    <td className='text-right'>
                      <select
                        onChange={(e) => { this.onSelectChange(e, item, 'value_pj') }}
                        defaultValue={item.value_pj}
                        disabled={profile !== 'itau'}
                      >
                        <option value='' />
                        <option value='P'>P</option>
                        <option value='M'>M</option>
                        <option value='G'>G</option>
                      </select>
                    </td>
                    <td className='text-right'>
                      <select
                        onChange={(e) => { this.onSelectChange(e, item, 'effort') }}
                        defaultValue={item.effort}
                        disabled={profile !== 'overmedia'}
                      >
                        <option value='' />
                        <option value='P'>P</option>
                        <option value='M'>M</option>
                        <option value='G'>G</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Grid>
    )
  }
}

Backlog.propTypes = {
  profile: string
}

const mapStateToProps = (state) => ({
  profile: state.app.user.profile
})

export default connect(mapStateToProps)(Backlog)



// WEBPACK FOOTER //
// ./src/components/Backlog.js